import React, { Component } from 'react';

import {NavBar} from '../containers/App';

import { Redirect } from 'react-router-dom';

import {setAppId} from '../Utils/Storage';



export default class Authform extends Component {

  componentDidMount() {
    this.props.initAuth();
  }

  setLink(e) {
    const { setLink, pushLink } = this.props
    const link = e.target.value
    setLink(link)
    // Автоматически извлекаем токен, если URL уже содержит все нужные параметры
    if (
      link.indexOf('access_token') !== -1 &&
      link.indexOf('user_id') !== -1 &&
      link.indexOf('expires_in') !== -1
    ) {
      pushLink()
    }
  }

  setId(e) {
    const { setId } = this.props;
    const id = e.target.value;
    setId(id);
    setAppId(id);
  }

  pushId(e) {
    e.preventDefault()
    const { pushId } = this.props;
    pushId();
  }


  render() {
    const {
      isValid,
      error,
      link,
      id,
      authlink,
      access_token,
      user_id
    } = this.props.auth;




  return (
    <div>
        {access_token && user_id &&
        <Redirect to="/" />
        }
        <NavBar />
        <div className="hero container has-text-centered">
          <div className="hero-body">
            <h2 className="title">Авторизация</h2>
            <p className="has-text-left">
              Вконтакте заботится о своих пользователях и считает,
              что нельзя массово сохранять фотографии и снимать лайки.
              Это противоречит их интересам.
              Поэтому для работы в приложении, нужна хитрая авторизация.
              Для работы приложения нужно создать собственное VK-приложение.
              Это занимает пару минут и нужно сделать один раз.
              Ваши данные обрабатываются только в браузере и никуда не передаются.
            </p>
            <br />
            <ol>
              <li className="has-text-left">
                Перейдите <a href="https://dev.vk.com/ru/apps/create" target="_blank" rel="noopener noreferrer">по этой ссылке</a> и создайте приложение типа <strong>Standalone</strong>.
                Введите любое название и нажмите «Подключить приложение».
                <img className="image" src={process.env.PUBLIC_URL + "/instruct1.jpg"} alt="Создание приложения ВКонтакте"/>
                <br />
              </li>
              <li className="has-text-left">
                Перейдите в «Настройки». Выберите «Приложение включено и видно всем».
                OpenAPI — «Включён». В поле «Адрес сайта» и «Базовый домен» введите что угодно.
                Нажмите «Сохранить изменения».
                <img className="image" src={process.env.PUBLIC_URL + "/instruct2.jpg"} alt="Настройки приложения"/>
                <br />
              </li>
              <li className="has-text-left">
                Скопируйте <strong>ID приложения</strong> и вставьте в поле ниже.
                <img className="image" src={process.env.PUBLIC_URL + "/instruct3.jpg"} alt="ID приложения"/>
                <br />
              </li>
              <li className="has-text-left">
                <div className="control">
                  <div className="field">
                    <input className="input" type="text" placeholder="Вставьте ID приложения сюда" value={id} onChange={ this.setId.bind(this) } />
                  </div>
                  <p><button className="button is-info" disabled={!id} onClick={this.pushId.bind(this)}>ПОДТВЕРДИТЬ</button></p>
                </div>
              </li>
              <li className="has-text-left">
                <p>Нажмите кнопку ниже — откроется страница авторизации ВКонтакте. Разрешите доступ и скопируйте <strong>весь URL</strong> из адресной строки.</p>
                <br />
                <p><a className="button is-info" disabled={!authlink} href={authlink} target="_blank" rel="noopener noreferrer">АВТОРИЗОВАТЬСЯ В ВК</a></p>
              </li>
              <li className="has-text-left">
                <p>Вставьте скопированный URL сюда — токен будет извлечён автоматически.</p>
                <div className="control">
                  <div className="field">
                    <input className="input" type="text" placeholder="Вставьте URL из адресной строки сюда" value={link} onChange={ this.setLink.bind(this) } />
                  </div>
                </div>
                {error
                  ? <p className="help is-danger">{error}</p>
                  : isValid
                    ? <p className="help is-success">Токен получен, выполняется вход…</p>
                    : null
                }
                <br />
                <p><button className="button is-info" disabled={!isValid} onClick={(e) => { e.preventDefault(); this.props.pushLink(); }}>ПОДТВЕРДИТЬ</button></p>
              </li>
            </ol>




          </div>




        </div>
    </div>
   )
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth.js